import React from 'react'
import ReactDOM from 'react-dom/client'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './authConfig'
import App from './App.jsx'
import './index.css'

const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL instance and handle redirect promises
msalInstance.initialize().then(() => {
  // Handle redirect promise after initialization
  msalInstance.handleRedirectPromise().then((response) => {
    // User has successfully authenticated via redirect
  }).catch((error) => {
    // Error handling redirect handled silently
  });

  // Render the app after MSAL is initialized
  ReactDOM.createRoot(document.getElementById('root')).render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>,
  );
});